var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-select', _vm._b({
    staticClass: "v-input--large w-lg-240px",
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.sort,
      callback: function ($$v) {
        _vm.sort = $$v;
      },
      expression: "sort"
    }
  }, 'v-select', Object.assign({}, _vm.$attrs, {
    items: _vm.items
  }), false));

}
var staticRenderFns = []

export { render, staticRenderFns }